// src/lib/labels.ts
import type { components } from "@/api/schema";
import type { Tone } from "@/design-system/tone";

type S = components["schemas"];
type Meta = { label: string; tone: Tone };
const m = <K extends string>(x: Record<K, Meta>) => x;

export const UNIT_STATUS = m<S["UnitStatus"]>({
  VACANT: { label: "شاغرة", tone: "mute" },
  RENTED: { label: "مؤجَّرة", tone: "ok" },
  UNDER_MAINTENANCE: { label: "بلاغ صيانة", tone: "warn" },
});
export const UNIT_TYPE: Record<S["UnitType"], string> = {
  RESIDENTIAL: "سكني", COMMERCIAL: "تجاري", OFFICE: "مكتب", WAREHOUSE: "مخزن",
};
export const PROJECT_STATUS = m<S["ProjectStatus"]>({
  ACTIVE: { label: "نشط", tone: "ok" },
  INACTIVE: { label: "متوقف", tone: "mute" },
});
export const CONTRACT_STATUS = m<S["ContractStatus"]>({
  DRAFT: { label: "مسودة", tone: "mute" }, ACTIVE: { label: "نشط", tone: "ok" },
  EXPIRED: { label: "منتهٍ", tone: "warn" }, CANCELLED: { label: "ملغى", tone: "bad" },
  TERMINATED: { label: "مفسوخ", tone: "bad" },
});
export const PAYMENT_STATUS = m<S["PaymentStatus"]>({
  PENDING: { label: "مستحقة", tone: "warn" }, PAID: { label: "مسددة", tone: "ok" },
  OVERDUE: { label: "متأخرة", tone: "bad" }, CANCELLED: { label: "ملغاة", tone: "mute" },
});
export const PAYMENT_METHOD: Record<S["PaymentMethod-Output"], string> = {
  APPLE_PAY: "Apple Pay", MADA: "مدى", CARD: "بطاقة", BANK_TRANSFER: "تحويل بنكي",
};
export const JOURNAL_STATUS = m<S["JournalEntryStatus"]>({
  DRAFT: { label: "مسودة", tone: "mute" }, POSTED: { label: "مرحّل", tone: "ok" },
});
export const ACCOUNT_TYPE: Record<S["app__modules__accounting__models__AccountType"], string> = {
  ASSET: "أصل", LIABILITY: "خصم", EQUITY: "حقوق ملكية", REVENUE: "إيراد", EXPENSE: "مصروف",
};
export const REGISTER_ACCOUNT_TYPE: Record<S["app__modules__auth__schemas__AccountType"], string> = {
  INDIVIDUAL: "فرد / مالك", VENDOR: "مورد",
};
export const DISBURSEMENT_STATUS = m<S["DisbursementStatus"]>({
  PENDING_REVIEW: { label: "بانتظار المراجعة", tone: "warn" },
  PENDING_APPROVAL: { label: "بانتظار الاعتماد", tone: "info" },
  APPROVED: { label: "معتمد", tone: "gold" },
  REJECTED: { label: "مرفوض", tone: "bad" },
  EXECUTED: { label: "منفَّذ", tone: "ok" },
});
export const OUTBOX_STATUS = m<S["OutboxEventStatus"]>({
  PENDING: { label: "معلّقة", tone: "warn" }, PROCESSING: { label: "قيد المعالجة", tone: "info" },
  SUCCEEDED: { label: "ناجحة", tone: "ok" }, RECONCILED: { label: "مطابَقة", tone: "ok" },
  FAILED: { label: "فاشلة", tone: "bad" }, DEAD_LETTER: { label: "فاشلة نهائياً", tone: "bad" },
  CANCELLED: { label: "ملغاة", tone: "mute" },
});
export const INTEGRATION_STATUS = m<S["IntegrationStatus"]>({
  MOCK: { label: "تجريبي", tone: "mute" }, SANDBOX: { label: "بيئة اختبار", tone: "warn" },
  PRODUCTION: { label: "إنتاجي", tone: "ok" }, MANUAL: { label: "يدوي", tone: "info" },
});
export const PRIORITY = m<S["PriorityLevel"]>({
  LOW: { label: "منخفض", tone: "info" }, MEDIUM: { label: "متوسط", tone: "warn" },
  HIGH: { label: "عالٍ", tone: "bad" }, CRITICAL: { label: "عاجل", tone: "bad" },
});
export const INSPECTION_TYPE: Record<S["InspectionType"], string> = {
  CHECK_IN: "محضر استلام", CHECK_OUT: "محضر تسليم", MAINTENANCE_REQUEST: "بلاغ صيانة",
};
export const INSPECTION_STATUS = m<S["InspectionStatus"]>({
  PENDING: { label: "قيد المعالجة", tone: "warn" }, APPROVED: { label: "بانتظار الإنهاء", tone: "info" },
  REJECTED: { label: "مرفوض", tone: "bad" }, COMPLETED: { label: "منتهٍ", tone: "mute" },
});
export const ROLE_LABEL: Record<S["UserRoleType"], string> = {
  OWNER: "مالك / ناظر", ADMIN: "مدير النظام", ACCOUNTANT: "محاسب", TENANT: "مستأجر", BENEFICIARY: "مستفيد",
  SUPERVISOR: "مشرف", VENDOR: "مورد",
};
